var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative has-tool-menu"},[_c('div',{staticClass:"tool-menu"},[_c('Breadcrumb'),_c('div',{staticClass:"buttons"},[_c('ButtonAreas')],1)],1),_c('suitsyouMeasurements')],1)}
var staticRenderFns = []

export { render, staticRenderFns }